import axios from "axios";
import React, { useEffect, useState } from "react";

const LocationStockTable = ({
  locationStockEntries,
  setLocationStockEntries,
  onlocationStockEntriesChange,
  formData,
  isEdit,
}) => {
  const data = formData?.locationStockEntries || [];

  const handleLocationChange = (index, key, value) => {
    const updated = [...data];
    updated[index] = {
      ...updated[index],
      [key]: value,
    };
    console.log("locationStockData:", updated);
    // If parent needs updated values
    if (onlocationStockEntriesChange) {
      onlocationStockEntriesChange(updated);
    }
  };

  return (
    <div className="mt-6">
      <div className="h-[400px] bg-white overflow-auto rounded-md shadow-sm border border-gray-200">
        <table className="w-full text-sm border-collapse">

          {/* Sticky Header */}
          <thead className="bg-gray-100 sticky top-0 z-10 ">
            <tr className="">
              <th className="px-4 py-3 text-left font-medium text-gray-700 ">
                Location Code
              </th>
              <th className="px-4 py-3 text-left font-medium text-gray-700 ">
                Location Name
              </th>
              <th className="px-4 py-3 text-center font-medium text-gray-700  ">
                Opening Qty
              </th>
              <th className="px-4 py-3 text-center font-medium text-gray-700 ">
                Current Qty
              </th>
              <th className="px-4 py-3 text-center font-medium text-gray-700 ">
                Bin Location
              </th>
              <th className="px-4 py-3 text-center font-medium text-gray-700 ">
                Min Qty
              </th>
            </tr>
          </thead>

          {/* Body scrolls independently */}
          <tbody className="divide-y divide-gray-200">
            {data.map((loc, index) => (
              <tr key={index} className="hover:bg-gray-50 transition-colors">
                {/* Location Code */}
                <td className="px-4 py-3 font-medium text-gray-900">
                  {loc.LCODE?.trim() || "-"}
                </td>

                {/* Location Name */}
                <td className="px-4 py-3 text-gray-700">
                  {loc.LOCATION?.trim() || "-"}
                </td>

                {/* Opening Qty */}
                <td className="px-4 py-3 text-center text-gray-600">
                  <input
                    type="number"
                    value={loc.OPEN_QTY ?? ""}
                    onChange={(e) =>
                      handleLocationChange(index, "OPEN_QTY", e.target.value)
                    }
                    className="border-none rounded px-2 py-1 w-24 text-center bg-transparent"
                  />
                </td>

                <td className="px-4 py-3 text-center font-semibold text-blue-600">
                  {Number(loc.QTY)}
                </td>

                <td className="px-4 py-3 text-center text-gray-600">
                  <input
                    type="text"
                    value={loc.BIN_LOC || ""}
                    onChange={(e) =>
                      handleLocationChange(index, "BIN_LOC", e.target.value)
                    }
                    className="border-none rounded px-2 py-1 w-24 text-center bg-transparent"
                  />
                </td>

                <td className="px-4 py-3 text-center text-gray-600">
                  <input
                    type="number"
                    value={loc.MINQTY ?? ""}
                    onChange={(e) =>
                      handleLocationChange(index, "MINQTY", Number(e.target.value))
                    }
                    className="border-none rounded px-2 py-1 w-20 text-center bg-transparent"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

  );
};

export default LocationStockTable;
